import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHead, Reveal } from "../components/Reveal";
import { INFO } from "../lib/site";

const VALUES = [
  ["Missão", "Desenvolver e industrializar máquinas e implementos agrícolas com segurança e qualidade, respeitando o indivíduo e o meio ambiente, atendendo às expectativas dos clientes internos e externos."],
  ["Visão", "Ser referência em soluções criativas na industrialização de máquinas e implementos para o setor agrícola, sendo reconhecida nacionalmente e referência de mercado no estado de São Paulo."],
  ["Valores", "Tradição aliada à tecnologia, prezando sempre pela qualidade e robustez dos equipamentos, além do melhor atendimento aos clientes e revendedores."],
];

export default function Sobre() {
  return (
    <div data-testid="sobre-page">
      <PageHead testid="sobre-head" eyebrow="Institucional" title="Sobre a SOLLUS"
        text="Tecnologia, eficiência e compromisso com o produtor rural." />
      <section className="container-x grid gap-10 py-12 lg:grid-cols-2">
        <Reveal>
          <div className="clip-notch overflow-hidden rounded-lg">
            <img src="/img/fachada.jpg" alt="Fachada da fábrica SOLLUS em Assis/SP" className="aspect-[4/3] w-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="eyebrow">Nossa história</p>
          <h2 className="mt-2 font-display text-4xl font-bold uppercase leading-none text-ink">Desde {INFO.fundacao}</h2>
          <p className="mt-4 text-base text-steel">A Sollus é uma das principais empresas do mercado agrícola nacional e internacional. Fundada há 30 anos na cidade de Assis/SP, nosso trabalho sempre foi pautado em qualidade, segurança e tecnologia, com o foco principal de prestar o melhor atendimento e garantir a satisfação do cliente.</p>
          <p className="mt-4 text-base text-steel">
            Fabricamos máquinas e implementos para diversas áreas do agro, com foco nos cultivos de cana-de-açúcar e grãos, além da linha completa de apoio. Estamos presentes em todo o Brasil por meio dos nossos representantes e já chegamos aos Estados Unidos, Paraguai, Chile, Angola e Guiana Francesa.
          </p>
          <dl className="mt-6 space-y-2 text-sm text-steel">
            <div><dt className="inline font-semibold text-ink">Razão social: </dt><dd className="inline">{INFO.razao}</dd></div>
            <div><dt className="inline font-semibold text-ink">Endereço: </dt><dd className="inline">{INFO.endereco}, {INFO.cidade}</dd></div>
          </dl>
        </Reveal>
      </section>
      <section className="bg-mist">
        <div className="container-x grid gap-5 py-12 md:grid-cols-3">
          {VALUES.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.08}>
              <div className="h-full rounded-lg border-t-4 border-brand bg-white p-6" data-testid={`valor-${t.toLowerCase()}`}>
                <h3 className="font-display text-3xl font-bold uppercase text-ink">{t}</h3>
                <p className="mt-2 text-sm text-steel">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <div className="container-x py-10">
        <Link to="/produtos" className="btn-dark" data-testid="sobre-produtos-btn">Conheça nossos produtos <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  );
}
